module.exports = __webpack_public_path__ + "media/student_lending_center/03-63311de3.png";